import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, QueryCommand, ScanCommand } from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_SUPPORTED_LOCATION_TABLE_REGION,
  REACT_APP_SUPPORTED_LOCATION_TABLENAME,
} = process.env;

/**
 * Queries the supported locations DynamoDB table directly.
 * Uses IAM credentials from Identity Pool.
 */
const queryLocations = async (credentials, { country, state }) => {
  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_SUPPORTED_LOCATION_TABLE_REGION,
      credentials,
    })
  );

  // If state is provided, query by state. Otherwise get all for country.
  // NOTE: Adjust KeyConditionExpression based on the actual table key schema / GSI
  const command = new QueryCommand({
    TableName: REACT_APP_SUPPORTED_LOCATION_TABLENAME,
    IndexName: 'country-index', 
        KeyConditionExpression: state
      ? '#country = :country AND #state = :state'
      : '#country = :country',
    ExpressionAttributeNames: {
      '#country': 'country',
      ...(state && { '#state': 'state' }),
    },
    ExpressionAttributeValues: {
      ':country': 'MYS',
      ...(state && { ':state': state }),
    },
  });

  const res = await docClient.send(command);
  return res.Items || [];
};

const handler = async (args, { getState, rejectWithValue }) => {
  try {
    const { credentials } = await fetchAuthSession();

    const allLocations = await queryLocations(credentials, {
      country: 'MYS',
      state: args?.state || null,
    });

    if (process.env.NODE_ENV !== 'production') {
      console.log('services.locations.getSupportedLocations@handler', 'fetched:', allLocations.length);
    }

    return {
      locations: allLocations,
      filtered_state: args?.state || '',
    };

  } catch (error) {
    console.error('services.locations.getSupportedLocations@handler', error);
    return rejectWithValue(error.message || error);
  }
};

const pending = (state, action) => ({
  ...state,
  loading: true,
});

const fulfilled = (state, action) => ({
  ...state,
  loading: false,
  lists: action.payload.locations,
  filtered_state: action.payload.filtered_state,
  initialized: true,
});

const rejected = (state, action) => ({
  ...state,
  loading: false,
});

export default {
  handler,
  pending,
  fulfilled,
  rejected,
};
